module.exports = __webpack_public_path__ + "img/bj.34ce3c74.jpg";